import React from 'react'
import MarkdownWrapper from '../../utils/markdown-wrapper'

const ImageWithText = ({ content }) => {
    const { title, alignment, image, citation } = content
    const renderOptionalHeader = () => {
        if (content?.title) {
            return (
                <div className="text-container-title title-wrapper">
                    <div className="title-stroke">
                        <h2>{title}</h2>
                    </div>
                </div>
            )
        }
    }

    if (!content) {
        return null
    }

    return (
        <div className="container">
            <div className={`content-band image-with-text ${alignment}`}>
                <div className="text-container">
                    { renderOptionalHeader() }
                    <div className="text-container-text">
                        <MarkdownWrapper content={content.content} />
                    </div>
                </div>
                <div className="image-block">
                    <img src={image?.url} alt={image?.alt} />
                    { citation && <div className="citation">{citation}</div> }
                </div>
            </div>
        </div>
    )
}

export default ImageWithText


